<div>
  <section class="form-tasklist">

    <mat-accordion class="retrofit-headers-align">

      <!--Permit signoff-->
      @if (taskPermitSignoff) {
        <mat-expansion-panel id="permit-signoff-panel"
          [expanded]="viewApprovalTask === 0"
          (opened)="setApprovalTask(0)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                              (taskPermitSignoff.statusCode === 700000001 || taskPermitSignoff.statusCode === 700000003)
                              && !waitingForPermitInfo,
                              'rejected': taskPermitSignoff.statusCode === 700000002,
                              'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('permit', taskPermitSignoff.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">
                  {{taskPermitSignoff.name}}
                </div>
                <small
                    [ngClass]="{'retrofit-task-status accepted':
                      taskPermitSignoff.statusCode === 700000001 && !waitingForPermitInfo,
                      'retrofit-task-status': true}">
                  {{loadTaskStatusValue('permit', taskPermitSignoff.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                <span>
                  {{taskPermitSignoff.userPrompt}}
                </span>
                @if ((taskPermitSignoff.statusCode === 700000001 || taskPermitSignoff.statusCode === 700000003) &&
                  this.application.inspectorFullname && this.application.inspectorFullname.length > 0) {
                  <span
                    >
                    (uploaded)
                  </span>
                }
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-sm="column wrap" fxLayoutGap="40px">
              <div fxFlex='75%' ngStyle.lt-md="{'width': '100%'}">
                <p class="retrofit-task-item-title">Permit Documents</p>
                <ebb-portal-file-list
                  [context]="'PostRetrofit'"
                  [title]="'Building Permit Files'"
                  [application]="application"
                  [task]="taskPermitSignoff"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-file-list>
                @if (canAddPermitInfo()) {
                  <form [formGroup]="addPermitInfo">
                    <mat-form-field
                      appearance="outline" md-no-float
                      style="width:100%; max-width:370px; margin-top: 1em;">
                      <mat-label id="permitTypepreretrofit-label" style="color: #377491; font-weight: 500; text-transform: uppercase;">
                        UPLOAD ADDITIONAL DOCUMENTATION
                      </mat-label>
                      <!-- Fix: Add 'aria-label' instead of 'aria-labelledby' -->
                      <mat-select
                        (selectionChange)="onPermitAddChange($event)"
                        id="permitTypepostretrofit"
                        name="permitTypepostretrofit"
                        formControlName="permitType"
                        aria-label="Upload Additional Documentation"
                        >
                        @for (item of additionalPermitOptions; track item) {
                          <mat-option [value]="item.label">
                            {{ item.label }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </form>
                }
                @if (progressSaveOptionalPermitDoc) {
                  <div style="margin-top: 12px;">
                    <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
                  </div>
                }
                <div style='margin: 21px 0px;'>
                  <ebb-portal-timespan-form
                    [application]="application"
                    [task]="taskPermitSignoff"
                    (eventEmitRetrofitTimespan)="onEmitTimeSpanFormUpdate($event)">
                  </ebb-portal-timespan-form>
                </div>
                <a
                  class="retrofit-task-inline-action-link"
                  href="javascript:void(0)"
                  (click)="onshowBuildingPermitInfo()">
                  <span style="font-size: 13px;">
                    Show Building Permit Information
                  </span>
                </a>
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-sm>Help</p>
                @for (helpLink of helpByTopic('permit'); track helpLink) {
                  <div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!--House photos-->
      @if (taskHousePhotos && taskHousePhotos?.stateCode == 0 ) {
        <mat-expansion-panel
          [expanded]="viewApprovalTask === 1" id="house-photos-panel-postretrofit"
          (opened)="setApprovalTask(1)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                              (taskHousePhotos.statusCode === 700000001 || taskHousePhotos.statusCode === 700000003),
                              'rejected': taskHousePhotos.statusCode === 700000002,
                              'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('house', taskHousePhotos.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">
                  {{taskHousePhotos.name}}
                </div>
                <small
                    [ngClass]="{'retrofit-task-status accepted': taskHousePhotos.statusCode === 700000001,
                    'retrofit-task-status': true}">
                  {{loadTaskStatusValue('house', taskHousePhotos.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                <span>
                  {{taskHousePhotos.userPrompt}}
                </span>
                @if (taskHousePhotos.statusCode === 700000001 || taskHousePhotos.statusCode === 700000003) {
                  <span
                    class="retrofit-task-summary todo">
                    (uploaded)
                  </span>
                }
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <ebb-portal-photos
                  [application]="application"
                  [task]="taskHousePhotos"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-photos>
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                @for (helpLink of helpByTopic('photos'); track helpLink) {
                  <div div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!--Water heater photos-->
      @if (taskHeaterPhotos) {
        <mat-expansion-panel id="water-heater-photos-panel"
          [expanded]="viewApprovalTask === 2"
          (opened)="setApprovalTask(2)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                [ngClass]="{'accepted':
                            (taskHeaterPhotos.statusCode === 700000001 || taskHeaterPhotos.statusCode === 700000003),
                            'rejected': taskHeaterPhotos.statusCode === 700000002,
                            'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('heater', taskHeaterPhotos.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">
                  {{taskHeaterPhotos.name}}
                </div>
                <small
                    [ngClass]="{'retrofit-task-status accepted': taskHeaterPhotos.statusCode === 700000001,
                    'retrofit-task-status': true}">
                  {{loadTaskStatusValue('heater', taskHeaterPhotos.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                <span>
                  {{taskHeaterPhotos.userPrompt}}
                </span>
                @if (taskHeaterPhotos.statusCode === 700000001 || taskHeaterPhotos.statusCode === 700000003) {
                  <span
                    class="retrofit-task-summary todo">
                    (uploaded)
                  </span>
                }
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <ebb-portal-photos
                  [application]="application"
                  [task]="taskHeaterPhotos"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-photos>
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                @for (helpLink of helpByTopic('photos'); track helpLink) {
                  <div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!--Crawlspace photos-->
      @if (taskCrawlspacePhotos) {
        <mat-expansion-panel id="crawlspace-photos-panel"
          [expanded]="viewApprovalTask === 3"
          (opened)="setApprovalTask(3)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
                [ngClass]="{'accepted':
                            (taskCrawlspacePhotos.statusCode === 700000001 || taskCrawlspacePhotos.statusCode === 700000003),
                            'rejected': taskCrawlspacePhotos.statusCode === 700000002,
                            'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('crawlspace', taskCrawlspacePhotos.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">
                  {{taskCrawlspacePhotos.name}}
                </div>
                <small
                    [ngClass]="{'retrofit-task-status accepted': taskCrawlspacePhotos.statusCode === 700000001,
                    'retrofit-task-status': true}">
                  {{loadTaskStatusValue('crawlspace', taskCrawlspacePhotos.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                <span>
                  {{taskCrawlspacePhotos.userPrompt}}
                </span>
                @if (taskCrawlspacePhotos.statusCode === 700000001 || taskCrawlspacePhotos.statusCode === 700000003) {
                  <span
                    class="retrofit-task-summary todo">
                    (uploaded)
                  </span>
                }
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                <ebb-portal-photos
                  [application]="application"
                  [task]="taskCrawlspacePhotos"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-photos>
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                @for (helpLink of helpByTopic('photos'); track helpLink) {
                  <div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!-- Receipts -->
      @if (taskReceipts) {
        <mat-expansion-panel id="receipts-panel"
          [expanded]="viewApprovalTask === 4" (opened)="setApprovalTask(4)">
          <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
            <mat-panel-title>
            <mat-icon class="retrofit-task-icon" [ngClass]="{
                  'accepted':
                  (taskReceipts.statusCode === 700000001 || taskReceipts.statusCode === 700000003)
                  && !waitingForReceiptInfo,
                  'rejected': taskReceipts.statusCode === 700000002,
                  'primary': true
                }">
                <div [innerHTML]="loadTaskStatusIconHtml('receipt', taskReceipts.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">
                  {{taskReceipts.name}}
                </div>
                <small
                [ngClass]="{'retrofit-task-status accepted':
                            taskReceipts.statusCode === 700000001 && !waitingForReceiptInfo,
                  'retrofit-task-status': true}">
                  {{loadTaskStatusValue('receipt', taskReceipts.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                <span>
                  {{ taskReceipts.userPrompt }}
                </span>
                @if ((taskReceipts.statusCode === 700000001 || taskReceipts.statusCode === 700000003) &&
                  this.application.permitCost > 0) {
                  <span
                    class="retrofit-task-summary todo">
                    (uploaded)
                  </span>
                }
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-sm="column wrap" fxLayoutGap="12px">
              <div fxFlex="80%">
                <div style="margin-top: 15px;">
                  <ebb-portal-receipt-list
                    [title]="'Receipts'"
                    [application]="application"
                    [task]="taskReceipts"
                    (emitReceiptUploadEvent)="onEmitDataFormUpdate($event)">
                  </ebb-portal-receipt-list>
                  <div style="margin-top: 32px;">
                    <ebb-portal-receipt-form
                      [application]="application"
                      [listOptionSets]="listOptionSets"
                      [task]="taskReceipts"
                      (emitReceiptFormChangeEvent)="onEmitDataFormUpdate($event)">
                    </ebb-portal-receipt-form>
                  </div>
                </div>
              </div>
              <div fxFlex="20%">
                <p class="retrofit-task-help-title" fxShow fxHide.lt-sm>Help</p>
                @for (helpLink of helpByTopic('receipts'); track helpLink) {
                  <div>
                    <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{ helpLink.linkText }}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

      <!--Payment authorization form-->
      @if (taskPaymentAuthorization && !isreadonly) {
        <mat-expansion-panel id="payment-authorization-panel"
          [expanded]="viewApprovalTask === 5"
          (opened)="setApprovalTask(5)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
            <mat-panel-title>
              <mat-icon class="retrofit-task-icon"
              [ngClass]="{'accepted':
                          (taskPaymentAuthorization.statusCode === 700000001 || taskPaymentAuthorization.statusCode === 700000003),
                          'rejected': taskPaymentAuthorization.statusCode === 700000002,
                          'primary': true  }">
                <div [innerHTML]="loadTaskStatusIconHtml('payment', taskPaymentAuthorization.statusCode)"></div>
              </mat-icon>
              <div>
                <div class="retrofit-task-name">
                  {{taskPaymentAuthorization.name}}
                </div>
                <small
                [ngClass]="{'retrofit-task-status accepted': taskPaymentAuthorization.statusCode === 700000001,
                'retrofit-task-status': true}">
                  {{loadTaskStatusValue('payment', taskPaymentAuthorization.statusCode)}}
                </small>
              </div>
            </mat-panel-title>
            <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
              @if (!authorizedPaymentSubmitted) {
                <span
                  class="retrofit-task-summary todo">
                  {{taskPaymentAuthorization.userPrompt}}
                </span>
              }
              @if (authorizedPaymentSubmitted && authorizedPaymentTo != null && authorizedPaymentTo.length > 0) {
                <span
                  class="retrofit-task-summary todo">
                  {{authorizedPaymentTo}} (authorized)
                </span>
              }
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                @if (!isContractor() && !isreadonly) {
                  <div>
                    <p class="retrofit-task-item-title">PAYMENT FORM</p>
                    <p>Authorize payment to either the homeowner or contractor.</p>
                    @if (isHomeowner() &&
                      (!application.eventApplicationSubmitted ||
                      (application.eventApplicationSubmitted &&
                      (taskPaymentAuthorization.approvalTaskItems[0].statusCode === 700000002 ||
                      taskPaymentAuthorization.approvalTaskItems[0].statusCode === 700000000)))) {
                      <div
                        style="margin-top: 18px;">
                        <button mat-raised-button color="primary"
                          (click)="onClickSubmitPaymentAuthorization()">
                          COMPLETE PAYMENT AUTHORIZATION
                        </button>
                      </div>
                    }
                    @if (application.eventApplicationSubmitted
                      && taskPaymentAuthorization.approvalTaskItems[0].statusCode === 700000002
                      && (taskPaymentAuthorization.approvalTaskItems[0].reasonWhy
                      && taskPaymentAuthorization.approvalTaskItems[0].reasonWhy.length > 0)) {
                      <div style="margin-top: 18px"
                        >
                        <p><span class="warn-text">Action required</span>: {{taskPaymentAuthorization.approvalTaskItems[0].reasonWhy}}</p>
                      </div>
                    }
                    @if (authorizedPaymentSubmitted && authorizedPaymentTo != null && authorizedPaymentTo.length > 0) {
                      <div class="retrofit-form-inline-icon-with-label-container"
                        >
                        <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">check_circle_outline</mat-icon>
                        <span class="retrofit-form-inline-icon-with-label-text">{{authorizedPaymentTo}} (authorized)</span>
                      </div>
                    }
                  </div>
                }
                @if (isContractor()) {
                  <div>
                    <p>
                      This section must be completed by homeowner.
                    </p>
                  </div>
                }
              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                @for (helpLink of helpByTopic('payment'); track helpLink) {
                  <div div>
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }

    </mat-accordion>
  </section>

  <br/>

</div>
